// Irreversible Cryptographic SHA-256 Hash verification for Offline Codes
// Plain codes are NEVER stored in the codebase or build bundle.

const DEFAULT_OFFLINE_HASHES = [
  "79d1507e9f880f450ba05108871e1c9d2036fe03fd2f86b107cdd819f174550c", // 0181519409618035
  "5df43c484045459a8bed32643faa3f77708595f43f3f4bd24cd284c0536d5739", // 5187702213753763
  "a018d5f5879164ae7b03fa38394caf7de7f2cde00aa2b0ab9cc1279ee3abcd53", // 2785536412170387
  "bd442a1083539f2985bbe3c47759eb6630b56407b93782efe7c0832db61052fd", // 4734320704983332
  "a18b4ef862d5f698644db0354d701e0fba037bbd3e451f7ef70fc30b0120e502"  // 7192661571404170
];

export const getAuthorizedOfflineHashes = () => {
  const envHashes = process.env.REACT_APP_LIC_OFFLINE_CODE_HASHES;
  if (envHashes) {
    return envHashes.split(',').map(h => h.trim().toLowerCase()).filter(Boolean);
  }
  return DEFAULT_OFFLINE_HASHES;
};

const computeCodeHash = async (codeStr) => {
  try {
    const text = codeStr.trim();
    const buffer = new TextEncoder().encode(text);
    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  } catch (err) {
    console.error("SHA-256 calculation error:", err);
    return null;
  }
};

/**
 * Asynchronously verifies if the entered 16-digit code matches an authorized hash.
 * @param {string} inputCode The code entered by the user.
 * @returns {Promise<boolean>} True if valid, false otherwise.
 */
export const verifyOfflineCode = async (inputCode) => {
  if (!inputCode) return false;
  const hash = await computeCodeHash(inputCode);
  if (!hash) return false;
  const validHashes = getAuthorizedOfflineHashes();
  return validHashes.includes(hash);
};
